<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="id_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-srollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i :class="icone"></i>
                            {{ titulo }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card" v-for="arquivoLink in arquivos" :key="arquivoLink.id_arquivo_link" >
                            <div class="card-body d-flex justify-content-between">
                                <div >
                                    <h5 class="card-title">Arquivo #{{ arquivoLink.id_arquivo_link }}</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Data: {{ data_formatada(arquivoLink.arquivo.created_at) }}</h6>
                                </div>
                                <div >
                                    <a :href="arquivoLink.arquivo.temporary_url" target="_blank" rel="noopener noreferrer">
                                        <i class="fas fa-link text-primary"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <div v-if="lista.last_page > 1"> 
                                <paginate :key="paginaUm"
                                    class="mb-0"
                                    :page-count="lista.last_page"
                                    :container-class="'pagination'"
                                    :page-class="'page-item'"
                                    :page-link-class="'page-link'"
                                    :prev-class="'page-link'"
                                    :next-class="'page-link'"
                                    :prev-text="'<<'"
                                    :next-text="'>>'"
                                    :click-handler="paginar">
                                </paginate>
                            </div>
                        </div>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import $ from 'jquery';
import moment from 'moment';

export default {


   data() {
    return {
        lista: [],
        tipoModelo: '',
        idModelo: '',
        tipoEspecial: '',
        paginaUm: true,
    }
   },

   props: ['titulo', 'icone'],
   
   computed: {
       id_modal() {
        
           return 'visArqModal' + this.tipoModelo + this.idModelo;
       },
       arquivos() {
            
        if (this.lista.data) {
                return this.lista.data;
            }

            return [];
       }
   },

   methods: {

         abrir_modal(tipoModelo, idModelo, tipoEspecial) {
              
            this.tipoModelo = tipoModelo;
            this.idModelo = idModelo;
            this.tipoEspecial = tipoEspecial;

            this.paginaUm = !this.paginaUm;

            this.$nextTick(() => {
                $('#' + this.id_modal).modal('show');
            });
            
            this.paginar(1);
         },

         paginar(page, size = 5) {

            this.$util.load(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.idModelo,
                    type: this.tipoModelo,
                    special_type: this.tipoEspecial,
                    page: page,
                    size: size,
                },
                loadTo: res => {
                    this.lista = res;
                }
            })


        },

        data_formatada(data) {
            return moment(data).format('DD/MM/YYYY HH:mm:ss') 
        },
   },

}
</script>